<app-filter-dropdown [formControl]="formControl" [label]="'global.filter.intent'" [multiple]="false" [options]="data" />
